import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref } from "vue";
import Clipboard from "clipboard";

export default /*#__PURE__*/_defineComponent({
  __name: 'TinyCopyBox',
  props: {
  val: String,
},
  setup(__props) {

const props = __props;

const showTip = ref(false);


const copy = () => {
  Clipboard.copy(props.val as string);
  showTip.value = true;
  setTimeout(() => {
    showTip.value = false;
  }, 1000);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("i", {
    class: "fa-regular fa-paste text-gray cursor-pointer position-relative",
    onClick: copy
  }, [
    (showTip.value)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(["tip fs-8 badge badge-light", { 'show-tip-animation': showTip.value }])
        }, _toDisplayString(_ctx.$t("fields.copied")), 3))
      : _createCommentVNode("", true)
  ]))
}
}

})